import React, { useState } from 'react'
import { Modal, ModalBody, ModalHeader } from 'components/utility/react-modal'

// Ported verbatim from the legacy PackageGuide#feesAuthorizedSwal branches so the display
// conditions stay unchanged — DOME-1437 is a design + copy update only. The two branches
// used to carry different body copy; product has since standardized on a single message,
// so these now only decide whether the modal shows at all.
const shouldShow = (props) => {
  const { hasFees, packageSubmitted, packageReadyForSubmission, allFeesAuthorized, packageGenerated } = props

  if (!hasFees) return false
  if (packageSubmitted) return false
  if (packageReadyForSubmission) return true
  return Boolean(allFeesAuthorized && !packageGenerated)
}

export function FeesAuthorizedModal(props) {
  const [isOpen, setIsOpen] = useState(() => shouldShow(props))

  if (!isOpen) return null

  return (
    <Modal isOpen onClose={() => setIsOpen(false)} className="submission-modal">
      <ModalHeader className="dome-align-center">
        <i className="fa-thin fa-circle-check dome-color-dark-green submission-modal-icon" />
        <span className="dome-h2 dome-color-dark-green">fees authorized</span>
      </ModalHeader>

      <ModalBody className="dome-gap12 dome-text-center">
        <span className="dome-p1 dome-color-dark-grey">
          You will be able to submit once all listed tasks have been completed.
        </span>
      </ModalBody>

      <div className="dome-d-flex dome-justify-center">
        <button type="button" onClick={() => setIsOpen(false)} className="dome-btn dome-btn-base dome-btn-aqua-stroke">
          OK
        </button>
      </div>
    </Modal>
  )
}

export default FeesAuthorizedModal
